<template>
  <article class="">
    <cabecera></cabecera>
    <!-- <section class="portada">
      <div class="linea">

        <h1>Relaciones Institucionales</h1>
      </div>
    </section> -->
    <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>Relaciones Institucionales</h2>
    </section>
   <!--  <section class="lineas">
      <div class="linea1"></div>
      <div class="linea2"></div>
      <div class="linea3"></div>
    </section> -->
    <section class="descripcion">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <p>En Compañía Mega S.A. hemos trabajado desde el comienzo de las operaciones en construir un vínculo entre nuestra
Compañía y los distintas partes interesadas de acuerdo con nuestro Manual de Gestión. De esta forma hemos desarrollado diferentes programas que nos han permitido acercarnos a la comunidad. Los públicos externos se componen, entre otros, de: clientes, proveedores, vecinos, superficiarios, entidades públicas y privadas, asociaciones civiles, ONG’s y medios de
comunicación.</p>

            <h5>Programa de Becas Acompañando a Crecer</h5>
            <p>
Compañía Mega S.A. desarrolla desde el año 2003 un programa de Becas Universitarias orientada a estudiantes egresados del sistema polimodal de Ingeniero White, mediante el cual se otorgan cinco becas anuales.
Este programa se lleva a cabo con la colaboración de la Fundación Cecilia Grierson, quien acompaña en la evaluación de los postulantes y en el seguimiento de las becas otorgadas.</p>
            <h6>Los requisitos para la inscripción son:</h6>
            <ul>
              <li><img  src="./check.png" alt="" >Obtener titulo de estudio de polimodal en establecimientos de Ingeniero White</li>
              <li> <img  src="./check.png" alt="" >Realizar estudios universitarios en la ciudad de Bahía Blanca</li>
              <li> <img  src="./check.png" alt="" >Tener promedio general de calificaciones en el polimodal no inferior a 8 puntos</li>
              <li> <img  src="./check.png" alt="" >No poseer otras becas o pasantías</li>
            </ul>
            <a href="static/pdf/reglamento2021.docx">VER REGLAMENTO DE BECAS</a>
            <div class="cont-pdf">
              <img class="img" src="./becas2021.png" alt="" >

            </div>
          </div>
        </div>
      <!--   <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <h5 class="subtitulo">Programa de Pasantías</h5>
            <p>Teniendo en cuenta la importancia de fomentar el vínculo con las universidades, la Compañía posee un Programa anual de pasantías rentadas para estudiantes universitarios con la Universidad Nacional del Sur (Bahía Blanca) y la Universidad Nacional del Comahue (Neuquén). Participan de dichas pasantías los alumnos que cursan carreras relacionadas con el proceso productivo, a los efectos de realizar tareas que les permitan mejorar su conocimiento en temas específicos y realizar sus tesis de estudio.</p>        
            <h5 class="subtitulo">Programa UNISOL</h5>
            <p>Es un programa solidario implementado a partir de una iniciativa del personal de la compañía quienes han conformado un grupo de ayuda llamado “Unisol”. El mismo tiene como fin recaudar dinero en forma mensual entre quienes desean colaborar voluntariamente, para ser donado con diferentes fines solidarios. Todos los meses, el grupo, a través de una votación, elige el destino del dinero recaudado (instituciones, tratamientos médicos, escuelas, etc.). Compañía Mega S.A. apoya a sus empleados, colaborando con este proyecto duplicando el monto del dinero recaudado y entregándolo a Unisol para que efectúe la donación correspondiente.</p>
            
            <h5 class="subtitulo">Participación en Instituciones</h5>
            <p>Como parte de su vínculo con otros organismos, Compañía Mega S.A. participa en las siguientes instituciones: Cámara de Concesionarios y Permisionarios del Puerto de Bahía Blanca, Instituto Argentino del Petróleo y Gas, Unión Industrial de Bahía Blanca, Instituto Petroquímico Argentino, FUNDECE (Fundación Empresaria para la Calidad y la Excelencia).</p>
          </div>
        </div> -->
        <div class="video">
          <h1>20 años Mega</h1>
          <div class="col-12 col-sm-12 col-md-10">
          <p style="text-align: center">El 1 de Abril de 2021 cumplimos 20 años y para celebrarlo elegimos contar nuestra historia en la voz de sus protagonistas. Pasado, presente y futuro de la compañía en los testimonios de las personas que son parte de la historia y del presente de Mega. En 2001 comenzó nuestra operación y nuestro objetivo de agregarle valor a la energía para llevarla a diferentes partes del país, la región y el mundo. #20AñosMega #LaVozDeNuestraHistoria #AgregamosValorALaEnergía</p>
        </div>
          <video controls playsinline src="./20anios.mp4"></video>
        </div>
      </div>
        <div class="banda-azul">
          <div class="texto">
            <h1>Seguí la actualidad y novedades de nuestra compañía en nuestras Redes</h1>
           <div class="rrss">
             <a target="_blank" href="https://ar.linkedin.com/company/ciamega"> <img src="./in.png" alt=""></a>
            <a target="_blank" href="https://www.youtube.com/channel/UCJIz0KFkNtsea_iY-H2b2cQ"> <img src="./yt.png" alt=""></a>
           </div>
          </div>
        </div>

    </section>
    <pie></pie>
  </article>
</template>

<script>
export default {
  name: 'relacionesInstitucionales',
  components: {
    Cabecera,
    Pie
  }
}
import Cabecera from '@/components/Cabecera'
import Pie from '@/components/Pie'
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.secundario p 
  margin-bottom: 10px
.cont-pdf
  width: 100%
  display: flex
  justify-content: space-around
.img
  margin: 20px auto
  width: 70%
  -webkit-transition: all .35s ease-in-out
  -moz-transition: all .35s ease-in-out
  -o-transition: all .35s ease-in-out
  -ms-transition: all .35s ease-in-out
  transition: all .35s ease-in-out
  &:hover
    width: 90%
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75)
    -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75)
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75)
.link-azul
  display: block
  text-align: center
  color: #004D9E
h5 
  color: #323232
  font-size: 16px
h6
  color: #004d9e
  font-size: 16px
  text-transform: uppercase
ul 
  padding-left: 15px
  padding-bottom: 30px
  @media (max-width: 550px)
    padding: 30px 0
  li
    list-style: none
    display: flex
    align-items: flex-start
    img
      margin: 0
      margin-right: 5px
      margin-top: 5px
a 
  text-align: center
  padding: 7px 18px
  background: #004d9e
  color: #fff
  font-weight: 600
  margin-bottom: 30px
  margin-left: 184px
  @media (max-width: 550px)
    margin: 0
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 50%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 28px
.video
  padding: 40px 0
  display: flex
  justify-content: center
  flex-direction: column
  align-items: center
  position: relative
  &:after
    content: ''
    height: 400px
    background: #004d9e
    width: 100%
    position: absolute
    z-index: 1
    top: 0
  h1
    text-align: center
    color: #fff
    font-size: 30px
    margin-top: 40px
    font-weight: 400
    position: relative
    z-index: 2
  div 
    z-index: 2
    position: relative
    p
      color: #fff
  video
    max-width: 960px
    position: relative
    z-index: 2
    width: 100%
.banda-azul
  background: #004d9e
  padding: 50px 0
  width: 100%
  .texto
    display: flex
    flex-direction: column
    align-items: center
    h1
      color: #fff
      font-size: 30px
      text-align: center
      font-weight: 400
      @media (max-width: 550px)
        font-size: 20px
    .rrss
      display: flex
      width: 100px
      a
        margin: 0
        padding: 0
</style>



// WEBPACK FOOTER //
// src/components/relaciones-institucionales/relacionesInstitucionales.vue